/* eslint-disable */

// This file is a an unformatted original GTM bootstrap.
// Because of this, it's as JS file rather than a typed one, and eslint is completely disabled here.
// Just leave it be unless you have a great reason to temper with it.

export function injectGTMCode() {
    (function (w, n, d, m, e, p) {
        w[d] =
            w[d] == 1 ||
                n[d] == 'yes' ||
                n[d] == 1 ||
                n[m] == 1 ||
                (w[e] && w[e].p && e[e][p]())
                ? 1
                : 0;
    })(
        window,
        'navigator',
        'doNotTrack',
        'msDoNotTrack',
        'external',
        'msTrackingProtectionEnabled',
    );
    (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        const f = d.getElementsByTagName(s)[0];
        const j = d.createElement(s);
        const dl = l != 'dataLayer' ? `&l=${l}` : '';
        j.async = true;
        j.src = `https://a.acronis.com/gtm.js?id=${i}${dl}`;
        f.parentNode.insertBefore(j, f);
    }(window, document, 'script', 'dataLayer', 'GTM-PFG6ZF'));
}
